import {
  ROUTE_PATH,
  TEMPLATE_OPTIONS,
  GENDERS,
  FORM_STEP_OPTIONS,
   ANYSCHOLARSHIP,
  CALLSTATUS,
  GENDERLIST_MENTOR,
  applicantGENDERS,
} from 'common/constants/sm-constants';
import {
  FormMetaModel,
  SmMetaSelectModel,
  SmMetaInputModel,
  SmBtnMetaModel,
  SmMetaTextAreaModel,
  SmToggleModel,
} from 'common/models/utility-models/meta-model';

export class ApplicantFilterMetaModel extends FormMetaModel {
  constructor() {
    super('', ROUTE_PATH.applicantGrid, '', 3);
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    const selectedRegion = new SmMetaSelectModel(
      'selectedRegion',
      'selectedRegion',
      'select',
      false,
      'col-sm-6 col-xs-12 col-md-4 col-lg-2',
      1,
      3,
      '',
      'select',
      'All Region',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'zone_name',
      'zone_name'
    );

    const selectedState = new SmMetaSelectModel(
      'selectedState',
      'selectedState',
      'select',
      false,
      'col-sm-6 col-xs-12 col-md-4 col-lg-2',
      1,
      3,
      '',
      'select',
      'All States',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'stateName',
      'id'
    );

    const department = new SmMetaSelectModel(
      'department',
      'department',
      'select',
      false,
      'col-sm-6 col-xs-12 col-md-4 col-lg-2',
      1,
      3,
      '',
      '',
      'Department',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'department_name',
      'id'
    );

    const allGenders = new SmMetaSelectModel(
      'allGenders',
      'allGenders',
      'select',
      false,
      'col-sm-6 col-xs-12 col-md-4 col-lg-2',
      1,
      3,
      '',
      'select',
      'All Genders',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      applicantGENDERS,
      'name',
      'id'
    );

    const status = new SmMetaSelectModel(
      'status',
      'status',
      'select',
      false,
      'col-sm-6 col-xs-12 col-md-4 col-lg-2',
      1,
      3,
      '',
      'select',
      'Select All',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      FORM_STEP_OPTIONS,
      'name',
      'name'
    );

    const search = new SmMetaInputModel(
      'search',
      'search',
      'input',
      false,
      'col-3',
      1,
      3,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const firstName = new SmMetaInputModel(
      'firstName',
      'firstName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'First Name',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const gender = new SmMetaSelectModel(
      'gender',
      'gender',
      'select',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Gender',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      'name',
      'value'
    );

    const middleName = new SmMetaInputModel(
      'middleName',
      'middleName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Middle Name',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const age = new SmMetaInputModel(
      'age',
      'age',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Age',
      'number',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const lastName = new SmMetaInputModel(
      'lastName',
      'lastName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Last Name',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const landlineNumber = new SmMetaInputModel(
      'landlineNumber',
      'landlineNumber',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Alternate Number',
      'number',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const mobileNumber = new SmMetaInputModel(
      'mobileNumber',
      'mobileNumber',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Mobile Number',
      'number',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const email = new SmMetaInputModel(
      'email',
      'email',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Email',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const city = new SmMetaInputModel(
      'city',
      'city',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'City/Town',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    //city

    const alternativeEmail = new SmMetaInputModel(
      'alternativeEmail',
      'alternativeEmail',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Alternate Email',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const stateId = new SmMetaSelectModel(
      'stateId',
      'stateId',
      'select',
      true,
      'col-12 col-md-6',
      1,
      1,
      'State/UT of domicile',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      [],
      'stateName',
      'id',

  );

    // const district = new SmMetaInputModel(
    //   'district',
    //   'district',
    //   'input',
    //   false,
    //   'col-12 col-md-6',
    //   1,
    //   1,
    //   'District',
    //   'email',
    //   '',
    //   false,
    //   true,
    //   true,
    //   false,
    //   100,
    //   1
    // );


  //   const district = new SmMetaSelectModel(
  //     'district',
  //     'district',
  //     'select',
  //     true,
  //     'col-12 col-md-6',
  //     1,
  //     1,
  //     'District',
  //     'select',
  //     '',
  //     false,
  //     true,
  //     true,
  //     false,
  //     0,
  //     0,
  //     false,
  //     [],
  //     'district',
  //     'id',

  // );

  const district_id = new SmMetaSelectModel(
    'district_id',
    'district_id',
    'select',
    true,
    'col-12 col-md-6',
    1,
    1,
    'District',
    'select',
    '',
    false,
    true,
    true,
    false,
    0,
    0,
    false,
    [],
    'district',
    'id',

);

    const familyAnnualIncome = new SmMetaInputModel(
      'familyAnnualIncome',
      'familyAnnualIncome',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Family Annual Income',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const fatherName = new SmMetaInputModel(
      'fatherName',
      'fatherName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Fathers Full Name',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const motherName = new SmMetaInputModel(
      'motherName',
      'motherName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Mothers Full Name',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const fatherProfession = new SmMetaInputModel(
      'fatherProfession',
      'fatherProfession',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Fathers Profession',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const motherProfession = new SmMetaInputModel(
      'motherProfession',
      'motherProfession',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Mothers Profession',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const score10 = new SmMetaInputModel(
      'score10',
      'score10',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      '10th Std Score',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const score12 = new SmMetaInputModel(
      'score12',
      'score12',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      '12th Std Score',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const physicsMarks = new SmMetaInputModel(
      'physicsMarks',
      'physicsMarks',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Physics',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const chemistryMarks = new SmMetaInputModel(
      'chemistryMarks',
      'chemistryMarks',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Chemistry',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const mathematicsMarks = new SmMetaInputModel(
      'mathematicsMarks',
      'mathematicsMarks',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Mathematics',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const jeeScore = new SmMetaInputModel(
      'jeeScore',
      'jeeScore',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'JEE/CET Score',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const instituteName = new SmMetaInputModel(
      'instituteName',
      'instituteName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Engineering College Name',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const instituteContact = new SmMetaInputModel(
      'instituteContact',
      'instituteContact',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Institute Phone',
      'number',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const instituteAddress = new SmMetaInputModel(
      'instituteAddress',
      'instituteAddress',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Institute Address',
      'email',
      '',
      false,
      true,
      true,
      false,
      200,
      1
    );


    const collageStateId = new SmMetaSelectModel(
      'collageStateId',
      'collageStateId',
      'select',
      true,
      'col-12 col-md-6',
      1,
      1,
      'College State',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      [],
      'stateName',
      'id',

  );


    const branchId = new SmMetaSelectModel(
      'branchId',
      'branchId',
      'select',
      true,
      'col-12 col-md-6',
      1,
      1,
      'Branch',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      [],
      'department_name',
      'id',
  );

    const firstYearFees = new SmMetaInputModel(
      'firstYearFees',
      'firstYearFees',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'First Year Fees',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const anyScholarshipName = new SmMetaInputModel(
      'anyScholarshipName',
      'anyScholarshipName',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Scholarship Name',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    // const anyScholarship = new SmMetaInputModel(
    //   'anyScholarship',
    //   'anyScholarship',
    //   'input',
    //   false,
    //   'col-12 col-md-6',
    //   1,
    //   1,
    //   'Other Scholarship',
    //   'text',
    //   '',
    //   false,
    //   true,
    //   true,
    //   false,
    //   100,
    //   1
    // );

    const anyScholarship = new SmMetaSelectModel(
      'anyScholarship',
      'anyScholarship',
      'select',
      true,
      'col-12 col-md-6',
      1,
      1,
      'Other Scholarship',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ANYSCHOLARSHIP,
      'name',
      'id',
  );

    const offeringInstitute = new SmMetaInputModel(
      'offeringInstitute',
      'offeringInstitute',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Offering Institute',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );
    const scholarshipAmount = new SmMetaInputModel(
      'scholarshipAmount',
      'scholarshipAmount',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      'Scholarship Amount',
      'email',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    const callStatus = new SmMetaSelectModel(
      'callStatus',
      'callStatus',
      'select',
      false,
      'col-12 col-md-6',
      1,
      1,
      '',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      CALLSTATUS,
      'name',
      'id',
  );


  const callRemark=new SmMetaTextAreaModel(
    'callRemark',
    'callRemark',
    'textarea',
    false,
    'col-12 col-md-6 ',
    1,
    2,
    'Remarks(if any)',
    'textarea',
    '',
    false,
    true,
    true,
    false,
    500,
    1
  );

  const callCount = new SmToggleModel(
    'callCount',
    'callCount',
    'toggle',
    false,
    'col-12 p-0 ',
    1,
    8,
    '',
    '',
    '',
    false,
    true,
    true,
    false,
    0,
    0,
    false,
    false,
    
    
);


  // const callStatusPopupData: any = {
  //   called: false,
  //   status: "0",
  //   remarks: "",
  // };
  // const callStatus:any='0'
  // const callStatusType: "reject" | "update" = "update";

  const submitData:any='';

    const buttons = {
      submit: new SmBtnMetaModel(
        'Save and Update',
        '',
        true,
        false,
        true,
        true
      ),
      reject: new SmBtnMetaModel('Reject', '', true, false, true, true),
      isFormControl: false,
    };

    const reject = {
      reject: new SmBtnMetaModel('Reject', '', true, false, true, true),
      isFormControl: false,
    };

    return {
      formInfo,
      selectedRegion,
      search,
      selectedState,
      department,
      allGenders,
      status,
      firstName,
      gender,
      middleName,
      age,
      lastName,
      landlineNumber,
      mobileNumber,
      email,
      city,
      buttons,
      reject,
      alternativeEmail,
      stateId,
      //district,
      district_id,
      familyAnnualIncome,
      fatherName,
      motherName,
      fatherProfession,
      motherProfession,
      score10,
      score12,
      physicsMarks,
      chemistryMarks,
      mathematicsMarks,
      jeeScore,
      instituteName,
      instituteContact,
      instituteAddress,
      collageStateId,
      branchId,
      firstYearFees,
      anyScholarship,
      offeringInstitute,
      scholarshipAmount,
      anyScholarshipName,
      callCount,
      callStatus,
      //callStatusType
      submitData,
      callRemark
    };
  }
}
